import React from 'react';
import { SvgIcon } from '@material-ui/core'

const EmergencyUrgency = (props) => (
  <SvgIcon
    viewBox="0 0 34.229 36.51"
    {...props}
  >
    <path 
      d="M198.988,136.727v12.021l3.395-1.976,6.929-4.034,2.263,3.953-6.929,4.034-3.4,1.976,3.395,1.976,6.93,4.034-2.263,3.953-6.93-4.034-3.395-1.976v12.02h-4.526V156.652l-3.394,1.976-6.93,4.034-2.263-3.953,6.93-4.034L192.2,152.7l-3.394-1.976-6.93-4.034,2.263-3.953,6.93,4.035,3.394,1.976V136.727h4.527m0-2.282h-4.526a2.273,2.273,0,0,0-2.263,2.282V144.8l-6.93-4.035a2.25,2.25,0,0,0-3.091.836l-2.263,3.952a2.291,2.291,0,0,0,.828,3.116l6.93,4.035-6.93,4.034a2.292,2.292,0,0,0-.828,3.117l2.263,3.952a2.258,2.258,0,0,0,1.962,1.142,2.235,2.235,0,0,0,1.13-.306l6.93-4.034v8.067a2.273,2.273,0,0,0,2.263,2.282h4.526a2.273,2.273,0,0,0,2.263-2.282V160.6l6.93,4.034a2.232,2.232,0,0,0,1.13.306,2.256,2.256,0,0,0,1.962-1.142l2.263-3.952a2.293,2.293,0,0,0-.828-3.117l-6.933-4.033,6.93-4.035a2.292,2.292,0,0,0,.829-3.116l-2.263-3.953a2.258,2.258,0,0,0-1.962-1.142,2.234,2.234,0,0,0-1.13.306l-6.93,4.034v-8.067a2.272,2.272,0,0,0-2.262-2.282Z" 
      transform="translate(-179.611 -134.445)"
    />
  </SvgIcon>
);

export default EmergencyUrgency;